import {
  BasketballEventStatusId,
  EventStatusId,
} from '@collector/sportsapi-client-legacy'

export const pitchOverlaySupportedStatuses: EventStatusId[] = [
  BasketballEventStatusId.FinishedRegularTime,
  BasketballEventStatusId.FinishedAfterOvertime,
  BasketballEventStatusId.FinishedAwardedWin,
  BasketballEventStatusId.Abandoned,
  BasketballEventStatusId.Postponed,
  BasketballEventStatusId.Cancelled,
]
